module.exports = "<ul class=\"rw-list\"\r\n    role=\"menu\">\r\n  <ng-transclude>\r\n  </ng-transclude>\r\n</ul>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/rw-list/rw-list.html
// module id = 2007
// module chunks = 0